<div class="settings  container">
    <h1 class="heading">
        <ng-container i18n="@@settings">Settings</ng-container>
    </h1>
    <hr />
    <app-inline-navigation [navData]="navData"></app-inline-navigation>
    <hr />
</div>
<router-outlet name='settings_outlet'></router-outlet>
